// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qZBi","colBig":"styles_colBig__3Vmh4","colSmall":"styles_colSmall__JHgDn"};